import React, { PureComponent, useState, useEffect, useRef } from "react";
import {
  Form,
  Button,
  Col,
  Row,
  message,
  Modal,
  Input,
  Select,
  Radio,
} from "antd";
import { useHistory } from "react-router-dom";
import mes1 from "images/edu/mes1.png";
import message01 from "images/soldier/message1.png";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { getCurrentUser } from "utils/storage";
import { getStatus } from "@/utils/methods";
import ApproveModal from "@/components/ApproveModal";
import Cascader from "@/components/Cascader";
const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;
require("./createAssistItem.scss");

const list = [
  {
    label: "姓名",
    name: "inquiryName",
    value: "",
    type: "input",
    require: true,
    placeholder: "请输入姓名",
  },
  // {
  //   label: "身份证号码",
  //   name: "inquiryCard",
  //   value:"",
  //   type: "input",
  //   require: true,
  //   placeholder: "请输入身份证"
  // },
  {
    label: "是否成立公司",
    name: "isIncorporation",
    value: "",
    type: "radio",
    require: true,
    placeholder: "请选择奖是否成立公司",
  },
  {
    label: "公司名称",
    name: "inquiryCompanyName",
    value: "",
    type: "input",
    require: true,
    placeholder: "请输入公司名称",
  },
  {
    label: "统一社会信用代码",
    name: "socialCreditCode",
    value: "",
    type: "input",
    require: true,
    placeholder: "请输入统一社会信用代码",
  },
  {
    label: "公司地址",
    name: "inquiryCompanyAddress",
    value: "",
    type: "input",
    require: true,
    placeholder: "请输入公司地址",
  },
  {
    label: "项目地址",
    name: "entrepreneurshipAddress",
    value: "",
    type: "input",
    require: true,
    placeholder: "请输入项目地址",
  },
  // {
  //   label:"项目名称",
  //   name:"inquiryProjectName",
  //   value:"",
  //   type:"input",
  //   require:true,
  //   placeholder:"请输入项目名称"
  // },
  {
    label: "区县",
    name: "chooseCounty",
    value: "",
    type: "area",
    require: true,
    placeholder: "请输入区县",
  },
  // {
  //   label:"项目地址",
  //   name:"entrepreneurshipAddress",
  //   value:"",
  //   type:"input",
  //   require:true,
  //   placeholder:"请输入项目地址"
  // },
  // {
  //   label: "公司地址",
  //   name: "inquiryCompanyAddress",
  //   value:"",
  //   type: "input",
  //   require: true,
  //   placeholder: "请输入公司地址"
  // },
  // {
  //   label: "统一社会信用代码",
  //   name: "socialCreditCode",
  //   value:"",
  //   type: "input",
  //   require: true,
  //   placeholder: "请输入统一社会信用代码"
  // },
  {
    label: "咨询内容",
    name: "inquiryContent",
    value: "",
    type: "TextArea",
    require: true,
    placeholder: "请输入咨询内容",
  },
  {
    label: "联系电话",
    name: "inquiryTel",
    value: "",
    type: "input",
    require: true,
    placeholder: "请输入联系电话",
  },
];

export default function DeucationTrainingPolicyDetail(props) {
  const [form] = Form.useForm();
  const [sourseId, setSourseId] = useState("");
  const [courseInfo, setCourseInfo] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [checkValue, setCheckValue] = useState(1);
  const modalRef = useRef([]);
  const history = useHistory();

  useEffect(() => {
    let sourseId = props.location.pathname.split("/").slice(-1);
    getDetail(sourseId[0]);
    setSourseId(sourseId[0]);
  }, [props.location.pathname]);
  //获取详情
  const getDetail = (data) => {
    console.log("id信息", data);
    let params = {
      id: data,
    };
    Http.getApplication(Request.specialistDetails(), { ...params }, (obj) => {
      console.log(obj);
      if (obj.code == 200) {
        setCourseInfo(obj.data);
      }
    });
  };
  const showModal = (e) => {
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1,
    });
    if (!getCurrentUser()) {
      message.error("还未登录，请先登录后再申请！");
      history.push("/login");
      return;
    }
    if (getCurrentUser().user_type != "2") {
      message.warn("非退役军人不可申请!");
      return;
    }
    getStatus().then((res) => {
      if (res === false) {
        modalRef.current.showModal();
        return;
      }
      e.stopPropagation();
      setModalVisible(true);
    });
  };
  const handleOk = (e) => {
    const formValue = form.getFieldsValue(true);
    console.log("formValue", formValue);
    if (!formValue.inquiryName) {
      message.error("请输入姓名");
      return;
    }
    // if (!formValue.inquiryCard) {
    //   message.error("请输入身份证号码");
    //   return;
    // }
    if (!formValue.inquiryTel) {
      message.error("请输入联系电话");
      return;
    }
    let newChooseCounty = "";
    if (formValue.chooseCounty && formValue.chooseCounty.provinceName) {
      console.log("1111111111111111");
      newChooseCounty = formValue.chooseCounty.provinceName;
      if (formValue.chooseCounty.cityName) {
        newChooseCounty = `${formValue.chooseCounty.provinceName},${formValue.chooseCounty.cityName}`;
        if (formValue.chooseCounty.countyName) {
          newChooseCounty = `${formValue.chooseCounty.provinceName},${formValue.chooseCounty.cityName},${formValue.chooseCounty.countyName}`;
        }
      }
      formValue.chooseCounty = newChooseCounty;
    }
    console.log("formValue", formValue);
    let params = formValue;
    Http.post(Request.specialistDetailsMake(), { ...params }, (obj) => {
      if (obj.code == 200) {
        message.success("申请成功", 2);
      }
    });
    setModalVisible(false);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };
  const handleChange = () => {};
  const handleConfirmSkuId = (index, text, item) => {
    console.log("index,text,item", index, text, item);
  };
  const onChange = (e) => {
    setCheckValue(e.target.value);
    console.log("eeeeeeeeeeeeeeeeeeee", e.target.value);
  };
  const spectionApplication = () => {
    const formItemLayout = {
      labelCol: {
        span: 7,
      },
      wrapperCol: {
        span: 15,
      },
    };
    console.log(
      "getFieldsValuegetFieldsValuegetFieldsValue",
      form.getFieldValue("isIncorporation")
    );

    return (
      <Form form={form}>
        {list.map((item, index) => {
          if (form.getFieldValue("isIncorporation") == 0) {
            if (
              item.name == "inquiryCompanyAddress" ||
              item.name == "inquiryCompanyName" ||
              item.name == "socialCreditCode"
            ) {
              return;
            }
          }
          if (
            form.getFieldValue("isIncorporation") == 1 ||
            form.getFieldValue("isIncorporation") == undefined
          ) {
            if (
              item.name == "inquiryProjectName" ||
              item.name == "entrepreneurshipAddress"
            ) {
              return;
            }
          }
          if (item.type == "input") {
            return (
              <Col span={24}>
                <Form.Item
                  name={item.name}
                  required={item.require || false}
                  {...formItemLayout}
                  label={item.label}
                >
                  <Input placeholder={`请输入${item.label}`} />
                </Form.Item>
              </Col>
            );
          } else if (item.type == "TextArea") {
            return (
              <Col span={24}>
                <Form.Item
                  name={item.name}
                  required={item.require || false}
                  {...formItemLayout}
                  label={item.label}
                >
                  <TextArea placeholder={"请输入咨询内容"} />
                </Form.Item>
              </Col>
            );
          } else if (item.type == "select") {
            return (
              <Col span={24}>
                <Form.Item
                  name={item.name}
                  required={item.require || false}
                  {...formItemLayout}
                  label={item.label}
                >
                  <Select defaultValue="lucy" onChange={handleChange}>
                    <Option value="jack">广东省</Option>
                    <Option value="lucy">广西省</Option>
                    <Option value="Yiminghe">云南省</Option>
                  </Select>
                </Form.Item>
              </Col>
            );
          } else if (item.type == "radio") {
            return (
              <Col span={24}>
                <Form.Item
                  name={item.name}
                  required={item.require || false}
                  {...formItemLayout}
                  label={item.label}
                  initialValue={1}
                >
                  <Radio.Group
                    onChange={onChange}
                    value={checkValue}
                    defaultValue={1}
                  >
                    <Radio value={1}>是</Radio>
                    <Radio value={0}>否</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            );
          } else if (item.type == "selectRegion") {
            return (
              <Col>
                {/* <span className="form_label" >{item.label}</span>
              <Cascader
                  options={options1}
                  showSearch
                  fieldNames={`${name}-${formIndex}`}
                  value={value}
                  onChange={(e) => { handleChange(e, `${name}-${formIndex}`) }}
                  placeholder="请选择地址"
                  style={{ width: 400 }}
              /> */}
              </Col>
            );
          } else if (item.type == "area") {
            return (
              <Col span={24}>
                <Form.Item
                  name={item.name}
                  required={item.require || false}
                  {...formItemLayout}
                  label={item.label}
                >
                  <Cascader placeholder="请选择地址" bespread={true} />
                </Form.Item>
              </Col>
            );
          }
        })}
      </Form>
    );
  };
  const renderBaesInfo = (data) => {
    if (data && data.length) {
      return data.map((item, index) => {
        return (
          <Col span={24} key={index}>
            <span>{item.name}</span>
            <span>{item.value}</span>
          </Col>
        );
      });
    }
  };
  let photoUrl = {};
  if (courseInfo.photoList !== undefined) {
    photoUrl =
      courseInfo.photoList[0] == undefined ? "" : courseInfo.photoList[0];
  }

  console.log("courseInfo", photoUrl);
  const courseList = [
    {
      name: "工作单位：",
      value: courseInfo?.epalExpertUnit || "",
    },
    {
      name: "从业时间：",
      value: courseInfo?.workTime || "",
    },
    {
      name: "擅长领域：",
      value: courseInfo?.epalExpertTechnology || "",
    },
    {
      name: "专家简介：",
      value: courseInfo?.epalExpertIntroduce || "",
    },
  ];
  return (
    <div className="EntrepreneurialExpertDetails_app">
      <div className="Base_Detils_Box">
        <span>
          当前位置：创业帮扶 /{" "}
          <span
            style={{ cursor: "pointer" }}
            onClick={() => history.push("/entrance/entrepreneurship")}
          >
            创业专家
          </span>
          /{" "}
        </span>
        <span style={{ color: "#3356C5" }}> 专家详情</span>
      </div>
      <div className="conBox">
        <div className="topbox">
          <div className="left" style={{ height: "auto" }}>
            <img src={photoUrl.photoUrl} alt="" />
          </div>
          <div className="right">
            <div className="courseInfoBox">
              <span className="courseName">{courseInfo.courseName}</span>
              <span className="btnBox">
                <span className="courseInfoList_top">
                  {courseInfo?.epalExpertName}
                </span>
                <div>
                  <Button
                    type="primary"
                    className="leftBtn"
                    onClick={(e) => {
                      showModal(e);
                    }}
                  >
                    申请创业巡诊
                  </Button>
                  <Button
                    onClick={() =>
                      history.push({
                        pathname: "/entrance/entrepreneurship",
                        params: { activeyKey: 3 },
                      })
                    }
                  >
                    返回
                  </Button>
                </div>
              </span>
            </div>

            <div className="courseInfoList">
              <Form
              // labelCol={{ span: 8 }}
              // wrapperCol={{ span: 16 }}
              >
                <Row gutter={[24, 2]}>
                  {courseInfo ? renderBaesInfo(courseList) : ""}
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="创业巡诊申请"
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={"确认申请"}
      >
        {spectionApplication()}
      </Modal>
      <ApproveModal ref={modalRef} />
    </div>
  );
}
